'use client';

import { useEffect } from 'react';
import { trackCTAClick } from '@/lib/analytics';

// One listener for every copy button the docs renderer puts beside a code
// block, so the blocks themselves stay server-rendered markup.
export default function DocsCodeCopy() {
  useEffect(() => {
    function onClick(event: MouseEvent) {
      const button = (event.target as HTMLElement | null)?.closest<HTMLButtonElement>('[data-docs-copy]');
      const code = button?.parentElement?.querySelector('pre');
      if (!button || !code) return;
      void navigator.clipboard.writeText(code.innerText.replace(/\n$/, '')).then(() => {
        button.dataset.copied = 'true';
        window.setTimeout(() => delete button.dataset.copied, 1500);
      });
      trackCTAClick({ cta_name: 'docs_copy_code', cta_location: 'docs_page', cta_destination: window.location.pathname });
    }
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  return null;
}
